/*
 *
 * Header reducer
 *
 */

import ActionTypes from './constants';
import { ContainerState } from './types';
import TabNames from './TabNames';
import ActionTypesSelection from 'containers/Configurator/constants/selection';

export const initialState: ContainerState = {
  activeTab: TabNames.cabinet,
  displayedTab: TabNames.cabinet,
};

function headerReducer(
  state: ContainerState = initialState,
  action: any,
): ContainerState {
  switch (action.type) {
    case ActionTypes.SWITCH_TAB_REQUEST:
      return {
        ...state,
        activeTab: action.payload.tab,
      };
    case ActionTypes.TAB_DISPLAYED_CHANGED:
      return {
        ...state,
        displayedTab: action.payload.tab,
      };
    case ActionTypesSelection.ADD_TO_SHELVES_SELECTION:
    case ActionTypesSelection.SHELVES_SELECTION:
      if (state.activeTab !== TabNames.shelves)
        return { ...state, activeTab: TabNames.shelves };
      break;
  }
  return state;
}

export default headerReducer;
